import React from 'react';
import Logo from '../../../images/logo-loader.png';
import './styles.css';

const LadditionLoader = (props) => {
  return (
    <div className="laddition-loader-container">
      <div className="pulse">
        <img
          alt="loader L'addition"
          className="loader"
          src={Logo}
          width="150px"
          height="150px"
        />
      </div>
    </div>
  );
};

export default LadditionLoader;
